const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;

const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) {
    return fallback;
  }

  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") {
    return true;
  }
  if (normalizedValue === "false") {
    return false;
  }

  return fallback;
};

export const config = {
  apiBaseUrl: apiBaseUrl ?? "https://api.lumiquests.com",
  // Email capture is temporarily disabled unless explicitly re-enabled.
  // While this flag is off, pre-checkout lead capture and onboarding persistence stay off too.
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, false)
} as const;
